class EmailSignupPopup extends ModalDialog {
  constructor() {
    super();

    const dismissButton = this.querySelector('[id^="PopupDismiss-"]');
    if (dismissButton) dismissButton.addEventListener('click', this.decline.bind(this));

    const form = this.querySelector('.email-signup-popup__newsletter-form');
    if (form) {
      form.addEventListener('submit', () => {
        try {
          sessionStorage.setItem('email-signup-popup-submitted', '1');
        } catch (error) {
          // storage unavailable (private browsing) — force-reopen detection will be skipped
        }
      });
    }
  }

  connectedCallback() {
    super.connectedCallback();

    let submittedThisPopup = false;
    try {
      submittedThisPopup = sessionStorage.getItem('email-signup-popup-submitted') === '1';
      sessionStorage.removeItem('email-signup-popup-submitted');
    } catch (error) {
      // storage unavailable (private browsing) — treat as not submitted
    }

    const hasFormResult = this.querySelector('.email-signup-popup__message--success, [id^="PopupNewsletter-error--"]');
    if (hasFormResult && submittedThisPopup) {
      this.show();
      if (this.querySelector('.email-signup-popup__message--success')) this.markDismissed(true);
      return;
    }

    if (this.isDismissed()) return;

    const timeoutSeconds = Number(this.dataset.timeout) || 0;
    this.timeoutId = setTimeout(() => this.show(), timeoutSeconds * 1000);
  }

  hide() {
    super.hide();
    clearTimeout(this.timeoutId);
  }

  decline() {
    this.hide();
    const stored = this.readDismissedState();
    if (stored && stored.permanent) return;
    this.markDismissed(false);
  }

  isDismissed() {
    const stored = this.readDismissedState();
    if (!stored) return false;
    if (stored.permanent) return true;
    const thirtyDaysMs = 30 * 24 * 60 * 60 * 1000;
    return Date.now() - stored.at < thirtyDaysMs;
  }

  markDismissed(permanent) {
    try {
      localStorage.setItem('email-signup-popup-dismissed', JSON.stringify({ at: Date.now(), permanent }));
    } catch (error) {
      // storage unavailable (private browsing) — popup just won't remember dismissal
    }
  }

  readDismissedState() {
    try {
      const raw = localStorage.getItem('email-signup-popup-dismissed');
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }
}

customElements.define('email-signup-popup', EmailSignupPopup);
